import styled from 'styled-components';

import { colours, device } from '../../styles/constants';
import { lg, xl } from '../../styles/mixins';

export const Button = styled.button({
  alignItems: 'center',
  backgroundColor: colours.red,
  borderRadius: 4,
  color: 'white',
  display: 'flex',
  fontSize: 15,
  fontWeight: 700,
  height: 50,
  justifyContent: 'space-between',
  lineHeight: 1,
  margin: '40px 25px 0',
  padding: '0 25px',
  transition: 'background-color 0.2s ease-in-out',
  width: 'calc(100% - 50px)',
  [`@media ${device.tabletL}`]: {
    borderRadius: lg(4),
    fontSize: lg(18),
    height: lg(62),
    margin: 0,
    marginTop: lg(45),
    padding: `0 ${lg(33)}px`,
    width: lg(210),
  },
  [`@media ${device.desktop}`]: {
    borderRadius: xl(4),
    fontSize: xl(18),
    height: xl(62),
    marginTop: xl(45),
    padding: `0 ${xl(33)}px`,
    width: xl(210),
  },
  '&:hover': {
    backgroundColor: colours.activeRed,
  },
  img: {
    height: 18,
    width: 7,
    [`@media ${device.tabletL}`]: {
      height: lg(22),
      width: lg(11),
    },
    [`@media ${device.desktop}`]: {
      height: xl(22),
      width: xl(11),
    },
  },
});
